import {useState} from 'react';

type MenuAnchor = undefined | HTMLElement;
type MenuActions = {
  open: (anchor: HTMLElement) => any;
  close: () => any;
  anchor: MenuAnchor;
};
type MenuStateProviderProps = {
  children: (actions: MenuActions) => JSX.Element;
};
const MenuStateProvider = (props: MenuStateProviderProps) => {
  const [menuAnchor, setMenuAnchor] = useState<MenuAnchor>(undefined);

  return props.children({
    anchor: menuAnchor,
    close: () => setMenuAnchor(undefined),
    open: setMenuAnchor,
  });
};

export default MenuStateProvider;
